module.exports = __webpack_public_path__ + "static/juji-9b6469081ec86de9026a66753390d10b.jpeg";